import React from 'react';
import { NavLink } from 'react-router-dom';

/**
 * Error est une page qui affiche un message d'erreur lorsque l'utilisateur tente d'accéder à une page qui n'existe pas.
 * Elle affiche un message d'erreur 404 et un lien pour retourner à la page d'accueil.
 * Le lien est créé en utilisant le composant NavLink de 'react-router-dom'.
 * 
 *

 */

const Error = () => {
    return (
        <div className="min-h-screen bg-gray-50 flex items-center justify-center py-12 px-4">
            <div className="max-w-md w-full text-center">
                <div className="card-theme">
                    <div className="mb-8">
                        <div className="text-9xl font-bold text-theme-primary mb-4">404</div>
                        <div className="text-6xl mb-4">😵</div>
                    </div>
                    
                    <h1 className="text-3xl font-bold text-theme-primary mb-4">
                        Oups! La page que vous demandez n'existe pas
                    </h1>
                    
                    <p className="text-gray-600 mb-8 text-lg">
                        Il semble que vous ayez suivi un lien cassé ou que la page ait été déplacée.
                    </p>
                    
                    <div className="space-y-4">
                        <NavLink 
                            to="/" 
                            className="btn-theme w-full"
                        >
                            <i className="fas fa-home mr-2"></i>
                            Retourner sur la page d'accueil
                        </NavLink>
                        
                        <button 
                            onClick={() => window.history.back()}
                            className="btn-theme-secondary w-full"
                        >
                            <i className="fas fa-arrow-left mr-2"></i>
                            Retour à la page précédente
                        </button>
                    </div>
                    
                    <div className="mt-8 pt-6 border-t border-gray-200">
                        <p className="text-sm text-gray-500">
                            Si vous pensez qu'il s'agit d'une erreur, contactez le support technique.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Error;